import { render, staticRenderFns } from "./AvatarList.vue?vue&type=template&id=02bf11de&"
import script from "./AvatarList.vue?vue&type=script&lang=js&"
export * from "./AvatarList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports